import { render, staticRenderFns } from "./InvoiceFormComponent.vue?vue&type=template&id=655ac8e8&scoped=true&"
import script from "./InvoiceFormComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceFormComponent.vue?vue&type=style&index=0&id=655ac8e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ac8e8",
  null
  
)

export default component.exports